import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, List, Clock, MapPin, Instagram, Facebook, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">

      {/* Main footer */}
      <div className="py-16 border-b border-gray-800">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid md:grid-cols-4 gap-12">
            <div className="space-y-6">
              <img src="/logo_molinaro.png" alt="Molinaro Immobiliare" className="h-20 brightness-0 invert" />
              <div className="text-gray-400">
                <p className="font-monomakh text-lg">MOLINARO IMMOBILIARE</p>
                <p>Studio Casellina s.a.s.</p>
                <p>P.IVA 06705840483</p>
              </div>
              <div className="flex space-x-4">
                <a href="https://www.instagram.com/molinaro_immobiliare/" target="_blank" rel="noopener noreferrer" className="bg-gray-800 hover:bg-secondary p-2.5 rounded-full text-white transition-colors">
                  <Instagram className="h-5 w-5" />
                </a>
                <a href="https://www.facebook.com/profile.php?id=61571288444118" target="_blank" rel="noopener noreferrer" className="bg-gray-800 hover:bg-secondary p-2.5 rounded-full text-white transition-colors">
                  <Facebook className="h-5 w-5" />
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-6 flex items-center">
                <List className="h-5 w-5 mr-2 text-secondary" />
                Collegamenti Rapidi
              </h4>
              <ul className="space-y-3 text-gray-400">
                <li>
                  <Link to="/" className="hover:text-secondary transition-colors flex items-center">
                    <ArrowRight className="h-3 w-3 mr-2" />
                    Home
                  </Link>
                </li>
                <li>
                  <Link to="/immobili" className="hover:text-secondary transition-colors flex items-center">
                    <ArrowRight className="h-3 w-3 mr-2" />
                    Immobili
                  </Link>
                </li>
                <li>
                  <Link to="/vendi-con-noi" className="hover:text-secondary transition-colors flex items-center">
                    <ArrowRight className="h-3 w-3 mr-2" />
                    Vendi con Noi
                  </Link>
                </li>
                <li>
                  <Link to="/chi-siamo" className="hover:text-secondary transition-colors flex items-center">
                    <ArrowRight className="h-3 w-3 mr-2" />
                    Chi Siamo
                  </Link>
                </li>
                <li>
                  <Link to="/contatti" className="hover:text-secondary transition-colors flex items-center">
                    <ArrowRight className="h-3 w-3 mr-2" />
                    Contatti
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-6 flex items-center">
                <MapPin className="h-5 w-5 mr-2 text-secondary" />
                Zone di Competenza
              </h4>
              <ul className="space-y-3 text-gray-400">
                <li>
                  <Link to="/agenzia-immobiliare-scandicci" className="hover:text-secondary transition-colors flex items-center">
                    <ArrowRight className="h-3 w-3 mr-2" />
                    Agenzia Immobiliare Scandicci
                  </Link>
                </li>
                <li>
                  <Link to="/case-in-vendita-scandicci" className="hover:text-secondary transition-colors flex items-center">
                    <ArrowRight className="h-3 w-3 mr-2" />
                    Case in Vendita a Scandicci
                  </Link>
                </li>
                <li>
                  <Link to="/vendere-casa-scandicci" className="hover:text-secondary transition-colors flex items-center">
                    <ArrowRight className="h-3 w-3 mr-2" />
                    Vendere Casa a Scandicci
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-6 flex items-center">
                <Clock className="h-5 w-5 mr-2 text-secondary" />
                Orari e Contatti
              </h4>
              <div className="space-y-4 text-gray-400">
                <div>
                  <p className="font-semibold text-white mb-1">Orari di Apertura</p>
                  <p>Lun - Ven: 9:30 - 12:30 | 15:30 - 19:30</p>
                  <p>Sab: Chiuso</p>
                  <p>Dom: Chiuso</p>
                </div>
                <div>
                  <p className="font-semibold text-white mb-1">Telefono</p>
                  <p>+39 327 8855115</p>
                  <p>055 752139</p>
                </div>
                <div>
                  <p className="font-semibold text-white mb-1">Email</p>
                  <p>info@molinaroimmobiliare.it</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="py-8">
        <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between">
          <p className="text-gray-500 text-center md:text-left mb-4 md:mb-0">
            &copy; {new Date().getFullYear()} Molinaro Immobiliare - Dal 2017 sul territorio
          </p>
          <div className="flex space-x-6 text-gray-500 items-center">
            <Link to="/privacy-policy" className="hover:text-secondary transition-colors">Privacy Policy</Link>
            <Link to="/cookie-policy" className="hover:text-secondary transition-colors">Cookie Policy</Link>
            <Link to="/sitemap" className="hover:text-secondary transition-colors">Sitemap</Link>
            <a href="https://www.unicorndigital.it" target="_blank" className="text-xs hover:text-secondary transition-colors opacity-60 hover:opacity-100">Web Design Unicorn Digital</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;